<template>
	<div class="wrap">
		<Title title="投票基本信息"></Title>
		<table class="table-column2" cellpadding="0" cellspacing="0">
			<tr>
				<th>投票名称</th>
				<td>{{model.voteName}}</td>
			</tr>
			<tr>
				<th>投票封面</th>
				<td>
					<img :src="model.coverUrl"/>
				</td>
			</tr>
			<tr>
				<th>开始时间</th>
				<td>{{model.startTime|datefmt2('YYYY-MM-DD HH:mm:ss')}}</td>
			</tr>
			<tr>
				<th>结束时间</th>
				<td>{{model.endTime|datefmt2('YYYY-MM-DD HH:mm:ss')}}</td>
			</tr>
			<tr>
				<th>是否显示</th>
				<td>
					<span v-if="model.showFlag==1">是</span>
					<span v-if="model.showFlag==0">否</span>
				</td>
			</tr>
			<tr>
				<th>规则说明</th>
				<td>{{model.voteRule}}</td>
			</tr>
		</table>
		<Title title="参选者详情"></Title>
		<el-table border :data="votePlayerList" style="width: 100%">
			<el-table-column label="头像">
				<template slot-scope="scope">
					<img style="width:45px; height: 45px;" :src="scope.row.avatorUrl"/>
				</template>
			</el-table-column>
			<el-table-column prop="voteNo" label="投票号">
			</el-table-column>
			<el-table-column prop="playerName" label="姓名">
			</el-table-column>
			<el-table-column prop="schoolName" label="学校">
			</el-table-column>
			<el-table-column prop="voteCount" label="票数">
			</el-table-column>
		</el-table>
		<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange"/>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam, config } from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	export default {
		name: 'VoteDetail',
		components: {
			Title,
			Pagination
		},
		data() {
			return {
				voteId: '',
				model: {},
				votePlayerList: [],
				pageSize: 10,
				pageNum: 1,
				total: 0
			}
		},
		created() {
			this.voteId = this.$route.query.id
			this.getDetailData()
			this.getVotePlayerList()
		},
		methods: {
			//获取投票详情
			async getDetailData() {
				let param = {
					id: this.voteId
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/detail', qs.stringify(param))
				this.model = res.data.entity
			},
			//获取参选者列表
			async getVotePlayerList(voteId) {
				let param = {
					voteId: this.voteId,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/voteInfo/votePlayerList', qs.stringify(param))
				if (res.data.code == 200) {
					let datalist = res.data.page.items
					this.votePlayerList = datalist
					this.total = res.data.page.count
				}
			},
			//分页
			handleCurrentChange(e){
				this.votePlayerList = []
				this.pageNum = e.number
				this.getVotePlayerList()
			}
		}
	}
</script>

<style scoped lang="less">
	@import '../../table.less';
	.table-column2{
		margin-bottom: 20px;
		img{
			width: 130px;
			height: 130px;
		}
	}
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}
</style>